import {
  aisle,
  asc,
  desc,
  eq,
  pantry_item,
  type PowerSyncDrizzleDB,
  shopping_item,
  shopping_list,
  shopping_list_organization,
} from "@mealplan/powersync";

/** Todas las listas visibles (propias + compartidas conmigo, ya sincronizadas). */
export function getShoppingListsQuery(db: PowerSyncDrizzleDB) {
  return db.select().from(shopping_list).orderBy(desc(shopping_list.updated_at));
}

export function getShoppingListByIdQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db.select().from(shopping_list).where(eq(shopping_list.id, listId)).limit(1);
}

/** Ítems de una lista ordenados para la vista (categoría → orden → nombre). */
export function getShoppingItemsQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db
    .select()
    .from(shopping_item)
    .where(eq(shopping_item.shopping_list_id, listId))
    .orderBy(asc(shopping_item.category), asc(shopping_item.sort_order), asc(shopping_item.name));
}

/** Organizaciones con las que está compartida la lista. */
export function getShoppingListOrganizationsQuery(db: PowerSyncDrizzleDB, listId: string) {
  return db
    .select()
    .from(shopping_list_organization)
    .where(eq(shopping_list_organization.shopping_list_id, listId));
}

export function getAislesQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(aisle)
    .where(eq(aisle.user_id, userId))
    .orderBy(asc(aisle.sort_order), asc(aisle.name));
}

export function getPantryQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(pantry_item)
    .where(eq(pantry_item.user_id, userId))
    .orderBy(asc(pantry_item.name));
}
